// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__33-p6","ul":"Sidebar_ul__1g1Nn","hideLi":"Sidebar_hideLi__Eaxo2","li":"Sidebar_li__2edRB","a":"Sidebar_a__3GcSn","liActive":"Sidebar_liActive__TOo76"};